import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IOptions from './IOptions';
import { message } from 'antd';

/**
 * 查询APP的详情
 */
class QueryAppInfo extends ApiBasic<IOptions, IAppInfo> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<IAppInfo>> {
        const req: Request = new Request(CallType.GET, Urls.queryAppInfo, option);
        req.isMessage = !!option.isMessage;
        delete req.options.isMessage;
        let data: any = await this.callAjax(req);
        
        // 提示双因子
        if (data.er) {
            if (data.er.body.status.returnCode === '54099') {
                message.error(data.er.body.status.description);
            }
        }
        return data;
    }
}

export default new QueryAppInfo().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/appStore/queryAppInfo/index.ts